// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ImageViewer-container__LtY96{display:flex;align-items:center;justify-content:center;width:var(--size-full);height:var(--size-full);overflow:hidden}.ImageViewer-container__LtY96>div{width:var(--size-full);height:var(--size-full)}.ImageViewer-image__QqoHc{width:var(--size-full);height:var(--size-full);-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ImageViewer-container__LtY96",
	"image": "ImageViewer-image__QqoHc"
};
export default ___CSS_LOADER_EXPORT___;
